import { render } from "./Copyright.vue?vue&type=template&id=5fa5570a&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5fa5570a"

export default script